import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkspaceRoutingModule } from './workspace-routing.module';
import { WorkspaceComponent } from './workspace.component';
import { AllStoryListingComponent } from '../all-story-listing/all-story-listing.component';
import { SharedModule } from '../../shared-module/shared.module';
import { MyDashboardComponent } from '../../my-dashboard/my-dashboard.component';
import { NotificationListComponent } from '../notification-list/notification-list.component';

@NgModule({
  imports: [
    CommonModule,
    WorkspaceRoutingModule,
    SharedModule
  ],
  declarations: [
    WorkspaceComponent,
    AllStoryListingComponent,
    MyDashboardComponent,
    NotificationListComponent
  ]
})
export class WorkspaceModule { }
